import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const LinkBottom = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='LinkBottom' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,5 L12,23 M4,13 L12,5 L20,13 M2,2 L22,2' transform='matrix(1 0 0 -1 0 24)' />
  </StyledIcon>
);
